// use-sessions-list.ts — Sessions-list suite, query (reads provider's infinite query)
//
// Returns the sidebar's session list as the contract `Session[]` shape (no FE re-shape),
// plus pagination handles. Provider owns the actual infinite-query; this hook just
// projects its snapshot.

'use client';

import { useSessionsListContext, type SessionsListSnapshot } from './SessionsListProvider';

export function useSessionsList(): SessionsListSnapshot {
  return useSessionsListContext().list;
}
